export const SET_NOTIFICATIONS = 'main/SET_NOTIFICATIONS';
export const UNSET_NOTIFICATIONS = 'main/UNSET_NOTIFICATIONS';

export const setNotifications = notifications => ({
  type: SET_NOTIFICATIONS,
  notifications,
});

export const unsetNotifications = () => ({
  type: UNSET_NOTIFICATIONS,
});



// WEBPACK FOOTER //
// ./main/actions/notifications-actions.js